import dtm from 'scripts/services/dtm';
import _ from 'lodash';

const findPlayers = (playersId, allPlayersList) =>
    allPlayersList.filter(({ identifier }) => playersId.includes(identifier));

const sortPlayers = (players) => _.sortBy(players, ['lastName', 'fistName']);

const findPlayersName = (players) =>
    players
        .map(({ firstName, lastName }) => `${firstName} ${lastName}`)
        .join(', ');

const getPlayersName = _.flow(
    findPlayers,
    sortPlayers,
    findPlayersName,
);

export function sendPlayerComparisonSelectionAnalytics(
    comparedPlayersId,
    allPlayersList,
) {
    if (!comparedPlayersId || !allPlayersList) {
        return;
    }

    const playersName = getPlayersName(comparedPlayersId, allPlayersList);

    dtm.trackPlayersCompareClick(playersName);
}
